import React, { ReactElement } from 'react';
import { Link } from 'lib/tanstack-router/routerAdapter';
// MATERIAL-UI
import Typography from '@mui/material/Typography';
// COMPONENTS
import EmptyState from '../common/EmptyState';

interface ForbiddenTypes {
  homePathUri?: string;
}

export default function Forbidden({ homePathUri = '/' }: ForbiddenTypes): ReactElement {
  const pageText = (
    <span>
      <Typography variant="body1" component="span">
        Access Denied. You are not authorized to access this page.
      </Typography>
      <Link to={homePathUri}>Home.</Link>
    </span>
  );

  return <EmptyState pageTitle="403 Forbidden" pageText={pageText} />;
}
